import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';
export default function UITooltipContent({
  className,
  children
}) {
  return /*#__PURE__*/_jsx("div", {
    className: classNames('private-tooltip__inner', className),
    role: "tooltip",
    children: children
  });
}
UITooltipContent.propTypes = {
  children: PropTypes.node
};
UITooltipContent.displayName = 'UITooltipContent';